import { render, staticRenderFns } from "./url2.vue?vue&type=template&id=5434d58c&scoped=true&"
import script from "./url2.vue?vue&type=script&lang=js&"
export * from "./url2.vue?vue&type=script&lang=js&"
import style0 from "./url2.vue?vue&type=style&index=0&id=5434d58c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5434d58c",
  null
  
)

export default component.exports